import { useLocation, useNavigate } from "react-router-dom"
import { memo, useCallback, useEffect, useState } from "react"

//Components
import Snack from '../../components/snack'
import Loader from "../../components/loader"
import NavBar from "./components/nav-bar"
import clinicCard from "./components/clinic-card"

//Extras
import { fontType } from "../../assets/extras"
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore"
import { db } from "../../assets/connections"
import { horas, niveles } from "../../assets/coach-assets/constants/datas"
import { getCurrentDay } from "../../assets/validator"
import ClinicCard from "./components/clinic-card"

const CoachRecords = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const academias = location.state ? location.state.academias : null
    const correo = location.state ? location.state.correo : null
    const nombre_profesor = location.state ? location.state.nombre_profesor : null

    //Variables principales del componente
    const [variables, setVariables] = useState({
        ref: null,
        correo: correo,
        academias: academias,
        selectedAcademia: "",
        loading: true,
        clinics: [],
        conteo: 0,
        horasT: 0,
        refreshing: false
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Variable que almacena los datos ordenados por dias
    let sortedDaysData = [
        [], //Extras
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for (let i = 0; i < 7; i++) {
            if (i === 0) { //Lunes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Lunes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 1) { //Martes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Martes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++;
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 2) { //Miercoles
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Miercoles") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 3) { //Jueves
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Jueves") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 4) { //Viernes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Viernes") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 5) { //Sabado
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Sabado") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 6) { //Domingo
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Domingo") {
                        sortedDaysData[i + 1].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            }
        }
    }

    const getData = async () => {
        if (variables.academias) {
            let aux = []
            for (let i = 0; i < variables.academias.length; i++) {
                await getDoc(doc(db, "Academias", academias[i])).then(r => {
                    aux.push({
                        id: variables.academias[i],
                        nombre: r.data().nombre_academia
                    })
                })
            }

            setVariables(prev => ({
                ...prev,
                academias: aux
            }))

            await getRef(aux[0])

        } else {
            return
        }
    }
    //Funcion que obtiene la referencia de la academia
    const getRef = async (a = variables.academias[0]) => {
        if (a) {
            await getDoc(doc(db, "Academias", a.id)).then(r => {
                getClinics(r.ref)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false,
                    refreshing: false
                }))
                showMessage("Error al obtener los datos", "error")
            })
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false,
                refreshing: false
            }))
        }
    }
    //Funcion que obtiene los registros de alguna clase de algun dterminado centro desportivo
    const getClinics = async (ref) => {
        try {
            // Obtener clases donde es profesor principal
            const clasesProfesorPrincipal = await getDocs(query(collection(ref, "Clases"), where("profesor_clase", "==", correo)))

        // Obtener clases donde es profesor secundario
        const clasesProfesorSecundario = await getDocs(query(collection(ref, "Clases"), where("profesor_clase_secundario", "==", correo)))

        // Combinar resultados y eliminar duplicados
        const clasesMap = new Map()

        clasesProfesorPrincipal.docs.forEach(doc => {
            clasesMap.set(doc.id, doc)
        })

        clasesProfesorSecundario.docs.forEach(doc => {
            if (!clasesMap.has(doc.id)) {
                clasesMap.set(doc.id, doc)
            }
        })

        // Convertir el Map a array
        const allDocs = Array.from(clasesMap.values())

        let aux = []
        let sort = niveles.map(v => []) //Obtenemos un arreglo con las listas por cada nivel
        sort.push([])
        allDocs.map(v => {
                const id = v.id
                //Validamos si es una clase normal/sustitucion o una clase extracurricular
                if (id.split("-").length === 1 || id.split("-")[2] === "TEMP") {
                    var newObject = {
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        nombre_profesor: v.data().nombre_profesor,
                        nivel: v.data().nivel,
                        dias_clase: v.data().dias_clase,
                        profesor_clase: v.data().profesor_clase,
                        descripcion_clase: v.data().descripcion_clase
                    }

                    //Ordenamos las clases por nivel
                    for (let i = 0; i < niveles.length; i++) {
                        if (niveles[i] === newObject.nivel) {
                            sort[i + 1].push(newObject)
                            break
                        }
                    }
                } else {
                    var newObject = {
                        id: v.id,
                        nombre_clase: v.data().nombre_clase,
                        nombre_profesor: v.data().nombre_profesor,
                        profesor_clase: v.data().profesor_clase,
                        descripcion_clase: v.data().descripcion_clase
                    }
                    sort[0].push(newObject)
                }
            })

            //Agregamos nuestra clase extracurricular a la lista general de clases
            for (let i = 0; i < sort[0].length; i++) {
                aux.push(sort[0][i])
            }

            //Tenemos como resultado una lista de listas que tiene ordenadas las clases por niveles
            //Ahora tenemos que ordenar cada lista de niveles por dias
            for (let i = 1; i < sort.length; i++) {

                let clases = sort[i] //Lista de clases de alguna etapa

                //Ordenamos cada clase de la lista de las categorias por dias
                for (let j = 0; j < clases.length; j++) {
                    //Recibimos una sola clase de la lista+
                    sortByDay(clases[j])
                }

                //Uva vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for (let j = 0; j < sortedDaysData.length; j++) {

                    //Primero creamos una variable que contendra las horas de clase
                    let h = horas.map((v, i) => [])

                    for (let x = 0; x < sortedDaysData[j].length; x++) {

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        let start = []

                        //Recorremos cada dia de las clases
                        for (let z = 0; z < sortedDaysData[j][x].dias_clase.length; z++) {
                            //Las agregamos a la variable de almacenamiento de las horas (ahora en formato "HH:MM")
                            start.push(sortedDaysData[j][x].dias_clase[z].de)
                        }


                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for (let z = 0; z < h.length; z++) {
                            // Comparar directamente con el valor en horas[z] (formato "HH:MM")
                            if (start.includes(horas[z])) {
                                h[z].push(sortedDaysData[j][x])
                                break
                            }
                        }

                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux.push(v2)
                        })
                    })

                }

                //Reiniciamos nuestra variable para el ordenamiento de las clases
                sortedDaysData = [
                    [], //Extras
                    [], //Lunes
                    [], //Martes
                    [], //Miercoles
                    [], //Jueves
                    [], //Viernes
                    [], //Sabado
                    [], //Domingo
                ]

            }

            getHistory(aux, ref)
        } catch (e) {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false,
                refreshing: false
            }))
            showMessage("Error al obtener las clases", "error")
        }
    }
    //Funcion que obtiene los registros totales del profesor de todas sus clases
    const getHistory = async (classes, ref) => {
        let sumaT = 0
        let horasT = 0

        for (let i = 0; i < classes.length; i++) {
            await getDoc(doc(ref, "Historial", classes[i].id)).then(r => {
                getRegs(r.ref, classes[i].id).then(s => {
                    sumaT += s.registros
                    horasT += s.horas

                    if (i === classes.length - 1) {
                        updateData(sumaT, horasT, classes)
                    }
                })
            })
        }

        setVariables(prev => ({
            ...prev,
            conteo: sumaT,
            horasT: horasT,
            clinics: classes,
            ref: ref.path,
            loading: false,
            refreshing: false
        }))
    }
    const getRegs = async (historyRef, id) => {
        let suma = 0
        let horas = 0
        await getDocs(query(collection(historyRef, "Historial"))).then(r => {
            r.docs.map(v => {
                if (v.data().duracion_clase) {
                    horas += parseInt(v.data().duracion_clase)
                }
            })
            suma += r.docs.length
        })

        return new Promise((resolve) => {
            resolve({
                registros: suma,
                horas
            })
        })
    }
    const updateData = (sumaT, horasT, classes) => {
        setVariables(prev => ({
            ...prev,
            clinics: classes,
            conteo: sumaT,
            horasT: horasT
        }))
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            console.log("SI")
            getData()
        }
    }, [])

    const HeaderComponent = memo(({ variables, setVariables }) => {
        return (
            <div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div
                        style={{
                            width: "90%",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderRadius: 10,
                            marginTop: 5,
                            borderColor: "#ddd",
                        }}
                    >
                        <select
                            value={variables.selectedAcademia || ""}
                            onChange={(e) => {
                                const selected = variables.academias.find(a => a.nombre === e.target.value);
                                if (selected) {
                                    setVariables((prev) => ({
                                        ...prev,
                                        selectedAcademia: selected.nombre,
                                        loading: true,
                                    }));
                                    getRef(selected);
                                }
                            }}
                            style={{
                                width: "100%",
                                color: "black",
                                backgroundColor: "white",
                                padding: "8px",
                                border: "none",
                                borderRadius: "10px",
                            }}
                        >
                            <option value="">Seleccionar academia</option>
                            {variables.academias &&
                                variables.academias.map((v, i) => (
                                    <option key={i} value={v.nombre}>
                                        {v.nombre}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                            marginBottom: 10,
                            marginTop: 20,
                        }}
                    >
                        <p
                            style={{
                                width: "100%",
                                fontSize: 18,
                                textAlign: "center",
                                fontWeight: "bold",
                                fontFamily: fontType.text
                            }}
                        >
                            {variables.conteo} clases / {variables.horasT} hrs
                        </p>
                    </div>
                </div>
            </div>
        )
    })

    const BodyComponent = memo(({ variables }) => {

        //Funcion que valida si la clase esta dentro del dia que deseamos obtener
        const validateDay = useCallback((dias) => {
            let today = getCurrentDay(new Date().getDay())
            let cont = 0

            for (let i = 0; i < dias.length; i++) {
                if (dias[i].dia == today) {
                    cont++
                }
            }

            if (cont > 0) {
                return true
            }
            return false
        }, [])

        //Funcion que nos manda a la informacion de la clinica
        const onNavigate = useCallback((v) => {
            navigate("/coach/record-info", {
                state: { 
                    id: v.id, 
                    ref: variables.ref
                }
            })
        }, [])

        return (
            <div style={{
                width: "100%",
                maxWidth: 1000,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly"
            }}>
                {
                    variables.clinics !== undefined ?
                        variables.clinics.length > 0 ?
                            !variables.todayClasses ?
                                variables.clinics.map((v, i) => 
                                    <ClinicCard
                                        data={v}
                                        onPress={onNavigate}
                                    />
                                )
                            :
                                variables.clinics.filter((v) => validateDay(v.dias_clase)).map((v, i) => 
                                    <ClinicCard
                                        data={v}
                                        onPress={onNavigate}
                                    />
                                )
                        :
                            null
                    : null
                }
            </div>
        )
    })

    if (variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if (!variables.loading)
        return (
            <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>

                <Snack />

                <NavBar
                    title={"HISTORIAL"}
                />

                <HeaderComponent
                    variables={variables}
                    setVariables={setVariables}
                />

                <BodyComponent
                    variables={variables}
                />

            </div>
        )
}

export default CoachRecords